import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { FileManagerService, UploadProgress } from '../../../../core/services/file-manager.service';
import { FileSizePipe } from '../../pipes/file-size.pipe';

@Component({
    selector: 'app-upload-progress',
    standalone: true,
    imports: [CommonModule, FileSizePipe],
    templateUrl: './upload-progress.component.html',
    styleUrls: ['./upload-progress.component.scss']
})
export class UploadProgressComponent implements OnInit, OnDestroy {
    uploads: Map<string, UploadProgress> = new Map();
    showProgress = false;
    minimized = false;
    private destroy$ = new Subject<void>();

    constructor(private fileManager: FileManagerService) {}

    ngOnInit(): void {
        this.fileManager.getUploadProgress()
            .pipe(takeUntil(this.destroy$))
            .subscribe(progress => {
                this.uploads.set(progress.id, progress);
                this.showProgress = true;

                if (progress.status === 'completed' || progress.status === 'error') {
                    setTimeout(() => {
                        this.uploads.delete(progress.id);
                        if (this.uploads.size === 0) {
                            this.showProgress = false;
                            this.minimized = false;
                        }
                    }, 3000);
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    toggleMinimize(): void {
        this.minimized = !this.minimized;
    }

    getActiveUploads(): UploadProgress[] {
        return Array.from(this.uploads.values());
    }

    getTotalProgress(): number {
        const uploads = this.getActiveUploads();
        if (uploads.length === 0) return 0;

        const totalProgress = uploads.reduce((sum, upload) => sum + upload.progress, 0);
        return Math.round(totalProgress / uploads.length);
    }
} 